// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGLinkIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  // flex: "0 0 auto",
  // cursor: "pointer"
  cursor: "pointer",
  display: "block",
};

export default class SVGLinkIcon extends PureComponent<ISVGLinkIconProps, {}> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M27.76,0.001c3.385-0.044,5.417,1.808,6.415,4.184
	c0.584,1.392,0.65,3.531,0.039,4.98c-0.612,1.453-1.681,2.358-2.709,3.387c-1.354,1.354-2.706,2.713-4.063,4.064
	c-0.839,0.834-1.661,1.685-2.511,2.51c-0.284,0.277-0.599,0.868-1.076,0.917c-0.068-0.068-0.111-0.06-0.159-0.159
	c-0.112-0.179,0.003-1.027,0-1.355c-0.005-0.7-0.152-1.377-0.319-1.912c-0.064-0.208-0.065-0.566,0.041-0.717
	c0.113-0.328,0.417-0.458,0.638-0.677c0.524-0.523,0.985-1.07,1.553-1.554c0.229-0.195,0.491-0.57,0.717-0.797
	c0.784-0.783,1.568-1.567,2.351-2.35c0.657-0.657,1.673-1.448,2.152-2.231c0.12-0.319,0.239-0.637,0.358-0.956
	c0.518-1.983-1.146-3.472-2.47-3.825c-1.813-0.484-2.93,0.94-3.746,1.633c-0.149,0.127-0.262,0.336-0.398,0.478
	c-0.518,0.54-1.064,1.064-1.594,1.594c-1.646,1.646-3.295,3.292-4.94,4.94c-0.847,0.849-2.249,1.814-2.391,3.307
	c-0.104,1.106,0.417,2.294,1.076,2.789c0.422,0.317,0.979,0.469,1.115,1.076c0.05,0.223-0.11,0.546-0.199,0.677
	c-0.255,0.376-0.725,0.664-1.036,0.996c-0.126,0.134-0.24,0.343-0.398,0.438c-0.174,0.104-0.529,0.165-0.757,0.08
	c-0.496-0.186-0.885-0.649-1.235-0.996c-0.81-0.801-1.419-1.745-1.793-2.988c-0.518-1.726-0.028-3.918,0.678-5.06
	c0.665-1.075,1.633-1.883,2.51-2.749c1.389-1.373,2.754-2.771,4.143-4.144c0.815-0.806,1.581-1.66,2.391-2.471
	c0.16-0.16,0.371-0.266,0.518-0.438c0.446-0.524,1.007-1.14,1.593-1.514C24.869,0.764,25.6,0.421,26.365,0.2
	C26.712,0.1,27.493,0.168,27.76,0.001z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M18.994,13.03c0.804,0.055,1.168,0.674,1.634,1.076
	c1.663,1.436,2.562,4.623,1.435,7.292c-0.758,1.792-2.526,3.123-3.825,4.422c-1.01,1.009-1.979,2.059-2.988,3.067
	c-0.663,0.664-1.391,1.268-2.032,1.953c-0.965,1.033-1.95,2.156-3.188,2.909c-1.178,0.716-3.382,1.104-5.061,0.597
	c-2.345-0.709-3.871-2.301-4.582-4.662c-0.244-0.812-0.403-2.023-0.159-2.988c0.148-0.586,0.294-1.122,0.518-1.634
	c0.5-1.145,1.444-1.922,2.271-2.749c1.315-1.314,2.633-2.626,3.944-3.944c0.941-0.945,1.889-1.884,2.83-2.829
	c0.26-0.262,0.742-0.955,1.155-0.996c0.069,0.068,0.111,0.06,0.159,0.159c0.111,0.179-0.002,1.027,0,1.355
	c0.005,0.7,0.152,1.377,0.319,1.912c0.064,0.208,0.065,0.566-0.041,0.717c-0.107,0.333-0.435,0.511-0.677,0.717
	c-0.134,0.113-0.232,0.313-0.359,0.438c-0.305,0.306-0.65,0.571-0.956,0.877c-1.17,1.166-2.297,2.377-3.467,3.546
	c-0.641,0.641-1.471,1.247-1.952,2.032c-1.218,1.988,0.255,4.137,1.793,4.702c0.608,0.223,1.664,0.147,2.191-0.08
	c0.743-0.32,1.185-0.867,1.713-1.395c0.625-0.625,1.249-1.248,1.873-1.872c1.155-1.156,2.349-2.273,3.506-3.427
	c0.406-0.405,0.746-0.917,1.196-1.275c0.49-0.391,1.003-0.904,1.395-1.394c0.221-0.277,0.584-0.471,0.797-0.757
	c0.507-0.683,0.953-1.858,0.597-2.949c-0.214-0.654-0.645-1.307-1.155-1.673c-0.209-0.149-0.502-0.217-0.678-0.398
	c-0.092-0.095-0.108-0.264-0.199-0.359c-0.014-0.285-0.045-0.482,0.079-0.717c0.21-0.398,0.833-0.824,1.156-1.155
	c0.086-0.089,0.141-0.246,0.239-0.318C18.619,13.123,18.839,13.131,18.994,13.03z"
        />
      </svg>
    );
  }
}
